export const EarningsTerm = {
	AllTime: 0,
	LastMonth: 1,
	HalfYear: 2,
};
